export enum PaymentType {
    'CreditCard', 'Account'
}
